import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'projectPage', en);
i18next.addResourceBundle('jp', 'projectPage', jp);

const ProjectConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/projects',
			exact: true,
			component: React.lazy(() => import('./Project'))
		}
	]
};

export default ProjectConfig;
